import type React from 'react';
import { Mail, Phone } from 'lucide-react';

/**
 * A workspace's PUBLIC contact tier on its profile page: the email and phone
 * it chose to publish from My Profile → Contact. The API sends it as
 * `publicContact` (utils/publicContact.ts) and never the direct tier, which
 * is only for people working a show with them.
 */

export interface PublicContact {
  email: string | null;
  phone: string | null;
}

const ProfileContact: React.FC<{ contact?: PublicContact | null }> = ({ contact }) => {
  const rows = [
    contact?.email ? { key: 'email', Icon: Mail, text: contact.email, href: `mailto:${contact.email}` } : null,
    contact?.phone ? { key: 'phone', Icon: Phone, text: contact.phone, href: `tel:${contact.phone.replace(/[^\d+]/g, '')}` } : null,
  ].filter((r): r is NonNullable<typeof r> => r !== null);

  if (rows.length === 0) return null;

  return (
    <div className="flex flex-col items-center gap-1.5 mt-4 max-w-full">
      {rows.map(({ key, Icon, text, href }) => (
        <a
          key={key}
          href={href}
          className="inline-flex items-center gap-2 text-sm text-grey-900 hover:underline break-all"
        >
          <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
          {text}
        </a>
      ))}
    </div>
  );
};

export default ProfileContact;
